(
    function (skyward, $, undefined)
    {
        skyward.massassignschedulingteams = skyward.massassignschedulingteams || {};

        var browseName = 'TempSchedulingTeamGradeReference';
        var isOverrideFieldName = "IsOverride";
        var overrideByFieldName = "OverrideBy";
        var toBeAssignedCountInputIDPrefix = "OverrideTotalToBeAssignedCount";
        var toBeAssignedPercentInputIDPrefix = "OverrideTotalToBeAssignedPercent";
        var toBeAssignedCode = "* Totals";
        var unassignedCode = "* Unassigned";

        var overrideCheckbox;
        var overrideByRadioSet;
        var overrideByValue;
        var isOverride = false;

        var totalObject;
        var unassignedObject;
        var teamObjects = new Array();
        var teamObjectIndexByTeamIDIndex = new Array();

        var totalStudentsToProcess = 0;
        var totalStudentsNeedToBeAssigned = 0;

        var columnOrder =
        {
            code: 0,
            descripiton: 1,
            maxcount: 2,
            currentcount: 3,
            totaltobeassigned: 4,
            totaltobeassignedpercent: 5,
            overridetotaltobeassigned: 6,
            overridetotaltobeassignedpercent: 7,
            totalstudents: 8
        };

        var init = function (selector) { totalObject = undefined; unassignedObject = undefined; teamObjects = new Array(); overrideCheckbox = undefined; overrideByRadioSet = undefined; };

        skyward.massassignschedulingteams.overrideEventHandler = function ()
        {
            if (overrideCheckbox == undefined)
            {
                overrideCheckbox = $("#" + isOverrideFieldName);
                totalStudentsToProcess = getBaseTenIntValue($("#TotalNumberOfStudentsSelected").val());
                totalStudentsNeedToBeAssigned = getBaseTenIntValue($("#TotalStudentsNeedToBeAssigned").val());
            }

            if (overrideCheckbox.prop('checked'))
            {
                isOverride = true;
                getInputElements();
                getOverrideRadioSet();
                if (overrideByRadioSet != undefined)
                {
                    skyward.controls.enable(overrideByRadioSet)
                }
                getOverrideByValueAndToggleInputEditable();
            }
            else
            {
                if (overrideByRadioSet != undefined)
                {
                    skyward.controls.disable(overrideByRadioSet)
                }
                isOverride = false;
                overrideByValue = "";
                toggleInputEditable();
            }
        };

        skyward.massassignschedulingteams.countBlurEventHandler = function(event)
        {
            var input = $(this);
            var id = getTeamID(input.attr("id"));
            var index = teamObjectIndexByTeamIDIndex[id];

            var newValue = 0;

            if (skyward.extensions.isNumeric(input.val()))
            {
                newValue = getBaseTenIntValue(input.val());
            }
            else //user didn't enter a value, set it to 0
            {
                teamObjects[index].countInput.val(newValue);
            }

            var oldValue = teamObjects[index].previousMaxToBeAssignedOverrideValue;;

            if (newValue == oldValue)
            {
                return;
            }

            //recalculate the team percentage
            var newPercentValue = checkTotalsForPercentAdjustment(index, getNewPercent(newValue));
            teamObjects[index].percentInput.val(newPercentValue);

            //update the team counts
            var newTotal = teamObjects[index].currentCount + newValue;
            teamObjects[index].totalStudentDiv.text(newTotal);
            teamObjects[index].previousMaxToBeAssignedOverrideValue = newValue;
            teamObjects[index].previousMaxToBeAssignedOverridePercentValue = newPercentValue;

            updateUnassignedAndTotal();
        }

        skyward.massassignschedulingteams.percentBlurEventHandler = function (event)
        {
            var input = $(this);
            var id = getTeamID(input.attr("id"));
            var index = teamObjectIndexByTeamIDIndex[id];

            var newValue = 0;
            if (skyward.extensions.isNumeric(input.val()))
            {
                newValue = getBaseTenIntValue(input.val());
            }

            //format the value
            teamObjects[index].percentInput.val(newValue);

            var oldValue = teamObjects[index].previousMaxToBeAssignedOverridePercentValue;
            if (newValue == oldValue)
            {
                return;
            }

            //recalculate the team count
            var newCountValue = checkTotalsForCountAdjustment(index, Math.round(totalStudentsNeedToBeAssigned * (newValue / 100)));
            teamObjects[index].countInput.val(newCountValue);
            teamObjects[index].countInput.trigger("change");

            //update the team counts
            var newTotal = teamObjects[index].currentCount + newCountValue;
            teamObjects[index].totalStudentDiv.text(newTotal);
            teamObjects[index].previousMaxToBeAssignedOverrideValue = newCountValue;
            teamObjects[index].previousMaxToBeAssignedOverridePercentValue = newValue;

            updateUnassignedAndTotal();
        }

        skyward.massassignschedulingteams.overrideByChangeEventHandler = function(event)
        {
            if (!isOverride)
            {
                return;
            }

            getOverrideByValueAndToggleInputEditable();
        }

        var checkTotalsForCountAdjustment = function(index, count)
        {
            var countSum = 0;
            var percentSum = 0;

            jQuery.each(teamObjects, function (i, team)
            {
                if (i == index)
                {
                    countSum += count;
                }
                else
                {
                    countSum += getBaseTenIntValue(team.countInput.val());
                }
                percentSum += Math.round(team.percentInput.val());
            })

            if (percentSum == 100)
            {
                if (countSum < totalStudentsNeedToBeAssigned)
                {
                    return count + (totalStudentsNeedToBeAssigned - countSum);
                }
                else
                {
                    return count - (countSum - totalStudentsNeedToBeAssigned);
                }
            }

            return count;
        }

        var checkTotalsForPercentAdjustment = function(index, percent)
        {
            var countSum = 0;
            var percentSum = 0;

            jQuery.each(teamObjects, function (i, team)
            {
                if (i == index)
                {
                    percentSum += percent;
                }
                else
                {
                    percentSum += Math.round(team.percentInput.val());
                }

                countSum += getBaseTenIntValue(team.countInput.val())
            })

            if (percentSum == 100 && countSum != totalStudentsNeedToBeAssigned)
            {
                if (countSum < totalStudentsNeedToBeAssigned)
                {
                    return percent - Math.round(countSum / totalStudentsNeedToBeAssigned);
                }
                else
                {
                    return percent + Math.round(countSum / totalStudentsNeedToBeAssigned);
                }
            }

            return percent;
        }

        var updateUnassignedAndTotal = function()
        {
            var countSum = 0;
            var percentSum = 0;
            var totalStudents = 0;

            jQuery.each(teamObjects, function (i, team)
            {
                countSum += getBaseTenIntValue(team.countInput.val());
                percentSum += Math.round(team.percentInput.val());
                totalStudents += getBaseTenIntValue(team.totalStudentDiv.text());
            })

            var newUnassignedCount = 0;
            var newUnassignedCountPercent = 0;
            var accumulatedPercentSum = percentSum;

            if (unassignedObject != undefined)
            {
                var tempUnassignCount = totalStudentsNeedToBeAssigned - countSum;
                if (tempUnassignCount > 0)
                {
                    newUnassignedCount = totalStudentsNeedToBeAssigned - countSum;
                }
                var newUnassignedCountPercent = getNewPercent(newUnassignedCount);
                var tempUnassignCountPct = newUnassignedCountPercent;

                var tempSum = accumulatedPercentSum + tempUnassignCountPct;
                if (tempSum != 100)
                {
                    if (tempSum < 100)
                    {
                        newUnassignedCountPercent = tempUnassignCountPct + (100 - tempSum);
                    }
                    else
                    {
                        newUnassignedCountPercent = tempUnassignCountPct - (tempSum - 100)
                    }

                    if (newUnassignedCountPercent < 0)
                    {
                        newUnassignedCountPercent = 0;
                    }
                }

                unassignedObject.countInput.val(newUnassignedCount);
                unassignedObject.percentInput.val(newUnassignedCountPercent);
                unassignedObject.totalStudentDiv.text(newUnassignedCount);
                unassignedObject.previousMaxToBeAssignedOverrideValue = newUnassignedCount;
                unassignedObject.previousMaxToBeAssignedOverridePercentValue = newUnassignedCountPercent;
            }

            var accummulatedPercentSum = percentSum + newUnassignedCountPercent;
            var accummulatedCountSum = countSum + newUnassignedCount;

            totalObject.countInput.val(accummulatedCountSum);
            totalObject.percentInput.val(accummulatedPercentSum);
            totalObject.totalStudentDiv.text(totalStudents);
            totalObject.previousMaxToBeAssignedOverrideValue = accummulatedCountSum;
            totalObject.previousMaxToBeAssignedOverridePercentValue = accummulatedPercentSum;
        }

        var getNewPercent = function (newCount)
        {
            if (totalStudentsNeedToBeAssigned > 0)
            {
                return Math.round((newCount / totalStudentsNeedToBeAssigned) * 100);
            }

            return 0;
        }

        var getBaseTenIntValue = function(value)
        {
            return parseInt(value, 10);
        }

        var getTeamID = function (inputID)
        {
            return inputID.split("-")[1];
        }

        var getOverrideByValueAndToggleInputEditable = function()
        {
            overrideByValue = skyward.controls.getValue(overrideByRadioSet);
            toggleInputEditable();
        }

        var toggleInputEditable = function ()
        {
            var initializeValues = false;
            jQuery.each(teamObjects, function(i, team)
            {
                if (isOverride && overrideByValue.toLowerCase() == "c")
                {
                    initializeValues = true;
                    skyward.controls.enable(team.countInput);
                    skyward.controls.disable(team.percentInput);
                }
                else if (isOverride && overrideByValue.toLowerCase() == "p")
                {
                    initializeValues = true;
                    skyward.controls.enable(team.percentInput);
                    skyward.controls.disable(team.countInput);
                }
                else
                {
                    skyward.controls.disable(team.countInput);
                    skyward.controls.disable(team.percentInput);
                }

                if (initializeValues)
                {
                    team.countInput.val(team.previousMaxToBeAssignedOverrideValue);
                    team.countInput.trigger("change");
                    team.percentInput.val(team.previousMaxToBeAssignedOverridePercentValue);
                }
                else
                {
                    team.countInput.val("");
                    team.percentInput.val("");
                    team.totalStudentDiv.text(team.totalStudentOriginalValue);
                }
            })

            if (initializeValues)
            {
                totalObject.countInput.val(totalObject.previousMaxToBeAssignedOverrideValue);
                totalObject.percentInput.val(totalObject.previousMaxToBeAssignedOverridePercentValue);

                unassignedObject.countInput.val(unassignedObject.previousMaxToBeAssignedOverrideValue);
                unassignedObject.percentInput.val(unassignedObject.previousMaxToBeAssignedOverridePercentValue);
            }
            else
            {
                totalObject.countInput.val("");
                totalObject.percentInput.val("");
                totalObject.totalStudentDiv.text(totalObject.totalStudentOriginalValue);

                unassignedObject.countInput.val("");
                unassignedObject.percentInput.val("");
                unassignedObject.totalStudentDiv.text(unassignedObject.totalStudentOriginalValue);
            }
        }

        var getOverrideRadioSet = function ()
        {
            if (overrideByRadioSet == undefined)
            {
                overrideByRadioSet = $("#" + overrideByFieldName);
                if (overrideByRadioSet.length)
                {
                    var name = overrideByRadioSet.attr("id");
                    var radioButtonSelector = 'input:radio[name="' + name + 'child"]';
                    var radioButtons = $(radioButtonSelector);
                    radioButtons.change(skyward.massassignschedulingteams.overrideByChangeEventHandler);
                }
            }
        };

        var getInputElements = function ()
        {
            if (totalObject == undefined)
            {
                $(":input[id^='" + toBeAssignedCountInputIDPrefix + "']").each(function()
                {
                    var countInput = $(this);
                    var id = countInput.attr('id');
                    var code;
                    var percentInput;
                    var maxCount = 0;
                    var currentCount = 0;
                    var totalToBeAssigned = 0;
                    var totalToBeAssignedPercent = 0.0;
                    var totalStudentDiv;

                    var isTotal = false;
                    var isUnassigned = false;
                    var isTeam = false;

                    var countInputTD = countInput.closest('td');
                    var parentTR = countInputTD.parent();

                    parentTR.children().each(function()
                    {
                        var child = $(this);

                        if (!child.is(countInputTD))
                        {
                            var column = getBaseTenIntValue(child.data("column"));

                            child.children().each(function ()
                            {
                                if ($(this).is('div'))
                                {
                                    var div = $(this);

                                    switch (column)
                                    {
                                        case columnOrder.code:
                                        {
                                            code = div.text();

                                            if (div.text() == toBeAssignedCode)
                                            {
                                                isTotal = true;
                                            }
                                            else if (div.text() == unassignedCode)
                                            {
                                                isUnassigned = true;
                                            }
                                            else
                                            {
                                                isTeam = true;
                                            }
                                            break;
                                        }
                                        case columnOrder.maxcount:
                                        {
                                            maxCount = div.text();
                                            break;
                                        }
                                        case columnOrder.currentcount:
                                        {
                                            currentCount = div.text();
                                            break;
                                        }
                                        case columnOrder.totaltobeassigned:
                                        {
                                            totalToBeAssigned = div.text();
                                            break;
                                        }
                                        case columnOrder.totaltobeassignedpercent:
                                        {
                                            totalToBeAssignedPercent = div.text();
                                            break;
                                        }
                                        case columnOrder.overridetotaltobeassignedpercent:
                                        {
                                            div.children().each(function ()
                                            {
                                                if ($(this).is("input[type='text']"))
                                                {
                                                    percentInput = $(this)
                                                }
                                            });
                                            break;
                                        }
                                        case columnOrder.totalstudents:
                                        {
                                            totalStudentDiv = div;
                                            break;
                                        }
                                    }
                                }
                            })
                        }
                    })

                    var object = createTotalObject(id, code, maxCount, currentCount, totalToBeAssigned, totalToBeAssignedPercent, countInput, percentInput, totalStudentDiv, isTeam);

                    if (isTotal)
                    {
                        totalObject = object
                    }
                    else if (isUnassigned)
                    {
                        unassignedObject = object;
                    }
                    else
                    {
                        teamObjectIndexByTeamIDIndex[getTeamID(id)] = teamObjects.push(object) - 1;
                    }
                });
            }
        };

        var createTotalObject = function (id, code, maxCount, currentCount, totalToBeAssigned, totalToBeAssignedPercent, countInput, percentInput, totalStudentDiv, isTeam)
        {
            var maxToBeAssignedOverrideValue = 0;
            var maxToBeAssignedOverridePercentValue = 0;

            maxCount = getBaseTenIntValue(maxCount);
            currentCount = getBaseTenIntValue(currentCount);

            if (isTeam)
            {
                countInput.off("blur", skyward.massassignschedulingteams.countBlurEventHandler).on("blur", skyward.massassignschedulingteams.countBlurEventHandler);
                percentInput.off("blur", skyward.massassignschedulingteams.percentBlurEventHandler).on("blur", skyward.massassignschedulingteams.percentBlurEventHandler);

                maxToBeAssignedOverrideValue = maxCount - currentCount;

                if (totalStudentsNeedToBeAssigned > 0)
                {
                    tempMaxPercent = maxToBeAssignedOverrideValue / totalStudentsNeedToBeAssigned;
                    if (tempMaxPercent > 1)
                    {
                        maxToBeAssignedOverridePercentValue = 1;
                    }
                    else
                    {
                        maxToBeAssignedOverridePercentValue = tempMaxPercent;
                    }
                }
            }

            return {
                id: id,
                code: code,
                maxCount: maxCount,
                currentCount: currentCount,
                countInput: countInput,
                percentInput: percentInput,
                totalStudentDiv: totalStudentDiv,
                totalStudentOriginalValue: totalStudentDiv.text(),
                maxToBeAssignedOverrideValue: getBaseTenIntValue(maxToBeAssignedOverrideValue),
                previousMaxToBeAssignedOverrideValue: getBaseTenIntValue(totalToBeAssigned),
                maxToBeAssignedOverridePercentValue: maxToBeAssignedOverridePercentValue,
                previousMaxToBeAssignedOverridePercentValue: totalToBeAssignedPercent
            };
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
)